import * as i1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import * as i0 from '@angular/core';
import { Injectable, Component, ViewEncapsulation, Inject, Input, NgModule } from '@angular/core';
import * as i1$2 from 'ngx-cookie-service';
import { CookieService } from 'ngx-cookie-service';
import * as i1$1 from '@am/moebius';
import { MB_DIALOG_DATA, MbIconModule, MbButtonModule, MbFormFieldModule, MbAlertModule } from '@am/moebius';
import * as i3 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i7 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as aci from '@am/common-svg-icons';

class AmExpertsShareService {
    constructor(http) {
        this.http = http;
        this.url = '/experts/compensations/api/share';
    }
    createShare() {
        return this.http.post(this.url, {});
    }
}
/** @nocollapse */ AmExpertsShareService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsShareService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ AmExpertsShareService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsShareService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsShareService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

const SPANISH_TRANSLATION = {
    shareProduct: 'Compartir enlace',
    shareTitle: 'Compartir enlace',
    shareInstructions: 'Para compartir este producto, copiá el enlace y pegalo en donde quieras.',
    shareAction: 'Copiar',
    defaultSuccess: 'Enlace copiado, ¡listo para compartir!',
    defaultError: 'Ups, lo sentimos, ha ocurrido un error.'
};
const PORTUGUESE_TRANSLATION = {
    shareProduct: 'Compartilhar link',
    shareTitle: 'Compartilhar link',
    shareInstructions: 'Para compartilhar esta oferta, copie o link abaixo.',
    shareAction: 'Copiar',
    defaultSuccess: 'Link copiado ¡pronto para compartilhar!',
    defaultError: 'Error'
};
const translation = {
    'es-AR': SPANISH_TRANSLATION,
    'es-CO': SPANISH_TRANSLATION,
    'es-MX': SPANISH_TRANSLATION,
    'pt-BR': PORTUGUESE_TRANSLATION
};
const siteXLocale = {
    ARG: 'es-AR',
    BRA: 'pt-BR',
    COL: 'es-CO',
    MEX: 'es-MX'
};
const DEFAULT_LOCALE = 'es-AR';

class TranslationService {
    constructor() { }
    getTranslation(locale) {
        return translation[locale] || translation[DEFAULT_LOCALE];
    }
    getTranslationFromSite(site) {
        return translation[siteXLocale[site]] || translation[DEFAULT_LOCALE];
    }
    getTranslationInstance(locale, text) {
        const translationInstance = translation[locale] || translation[DEFAULT_LOCALE];
        return translationInstance[text];
    }
}
/** @nocollapse */ TranslationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TranslationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ TranslationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TranslationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TranslationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class AmExpertsShareToastService {
    constructor(factoryResolver) {
        this.factoryResolver = factoryResolver;
    }
    /**
     * Set the view to hold the toast...
     * @return void
     */
    setRootViewContainerRef(viewContainerRef) {
        this.rootViewContainer = viewContainerRef;
    }
    /**
     * Show toast with configuration
     * IConfigToast
     *  component: Component to apply toast
     *  componentData: Data to pass to component
     *  timeOut: ttl toast
     * @return void
     */
    show(config) {
        const factory = this.factoryResolver.resolveComponentFactory(config.component);
        this.controllerInstance = factory.create(this.rootViewContainer.injector);
        this.controllerInstance.instance = Object.assign(this.controllerInstance.instance, config.componentData);
        if (config.timeOut) {
            setTimeout(() => this.close(), config.timeOut);
        }
        this.rootViewContainer.insert(this.controllerInstance.hostView);
    }
    /**
     * Close the instance toast
     * @return void
     */
    close() {
        this.controllerInstance.location.nativeElement.classList.add('toast-hoteles-fadeout');
        setTimeout(() => this.rootViewContainer.clear(), 2000);
    }
}
/** @nocollapse */ AmExpertsShareToastService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsShareToastService, deps: [{ token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ AmExpertsShareToastService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsShareToastService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsShareToastService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i0.ComponentFactoryResolver }]; } });

class AmExpertsShareModalComponent {
    constructor(translationService, modalRef, dialogData) {
        this.translationService = translationService;
        this.modalRef = modalRef;
        this.dialogData = dialogData;
    }
    ngOnInit() {
        this.translation = this.translationService.getTranslation(this.dialogData.locale);
    }
    trackEvent(eventAction, eventLabel) {
        const dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: 'trackEvent',
            eventCategory: 'Experts',
            eventAction: eventAction,
            eventLabel: eventLabel
        });
    }
    copyUrl() {
        this.trackEvent('CopyLink', this.dialogData.url);
        const element = document.querySelector('div.modal-body input.modal-body--url');
        element.setAttribute('readonly', '');
        element.select();
        document.execCommand('copy');
        setTimeout(() => {
            this.apply();
        }, 250);
    }
    apply() {
        this.modalRef.close({
            cancel: false,
            reason: 'LINK_COPIED',
            url: this.dialogData.url
        });
    }
}
/** @nocollapse */ AmExpertsShareModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsShareModalComponent, deps: [{ token: TranslationService }, { token: i1$1.MbDialogRef }, { token: MB_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ AmExpertsShareModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: AmExpertsShareModalComponent, selector: "am-experts-share-modal", inputs: { close: "close", dismiss: "dismiss", resolve: "resolve" }, providers: [], ngImport: i0, template: "<div class=\"am-experts-share-modal\">\n  <div class=\"modal-header\">\n    <p>{{translation.shareTitle}}</p>\n    <mb-icon icon=\"close\" (click)=\"modalRef.close()\"></mb-icon>\n  </div>\n  <div class=\"modal-body\">\n    <p class=\"modal-body--instructions\">\n      <mb-icon icon=\"link\"></mb-icon>\n      {{translation.shareInstructions}}\n    </p>\n    <div class=\"modal-body--copy\">\n      <input class=\"modal-body--url\" [(ngModel)]=\"dialogData.url\">\n        <button mb-button variant=\"principal\" color=\"primary\" class=\"modal-body--button\" (click)=\"copyUrl()\">{{translation.shareAction}}</button>\n    </div>\n  </div>\n</div>\n", styles: ["am-experts-share-modal{width:100%}am-experts-share-modal .am-experts-share-modal{font-family:ProximaNova,sans-serif}am-experts-share-modal .am-experts-share-modal *{box-sizing:content-box}am-experts-share-modal .am-experts-share-modal .modal-header{align-items:center;background-color:#dddede;color:#454848;display:flex;font-size:16px;height:auto;padding:0 16px;position:relative;text-align:left}am-experts-share-modal .am-experts-share-modal .modal-header .modal-header-title{font-size:16px;font-weight:700}am-experts-share-modal .am-experts-share-modal .modal-header mb-icon[icon=close]{cursor:pointer;position:absolute;right:21px;top:16px}am-experts-share-modal .am-experts-share-modal .modal-header p{line-height:48px;margin:0}am-experts-share-modal .am-experts-share-modal .modal-header>span{cursor:pointer;line-height:1em;position:absolute;right:16px;top:16px}am-experts-share-modal .am-experts-share-modal .modal-header>span.icon-close:before{content:\"\\ea01\";font-family:am-experts-share}am-experts-share-modal .am-experts-share-modal .modal-body{color:#454848;padding:16px}am-experts-share-modal .am-experts-share-modal .modal-body p.modal-body--instructions{font-size:16px;font-weight:400;line-height:20px;margin:8px 0}am-experts-share-modal .am-experts-share-modal .modal-body p.modal-body--instructions>span{font-size:14px;line-height:1em;margin-right:8px}am-experts-share-modal .am-experts-share-modal .modal-body p.modal-body--instructions>span.icon-link:before{content:\"\\ea03\";font-family:am-experts-share}am-experts-share-modal .am-experts-share-modal .modal-body input{box-sizing:border-box;color:#7c8080}am-experts-share-modal .am-experts-share-modal .modal-body input.modal-body--url{border:1px solid #bcbfbf;border-radius:3px 0 0 3px;font-size:14px;font-weight:400;line-height:17px;margin:8px 0;max-height:48px;outline:none;padding:16px 8px;width:80%}.cdk-overlay-pane.am-experts-share-modal-window{background:#fff;box-shadow:0 5px 15px #00000080;position:absolute!important;top:30px;width:600px}@media only screen and (max-width: 768px){.cdk-overlay-pane.am-experts-share-modal-window{bottom:0;box-shadow:0 5px 15px #00000080;top:0;width:100%}}.modal-body--copy{display:flex}.modal-body--button{margin:12px 0 0 14px}\n"], dependencies: [{ kind: "component", type: i1$1.MbIcon, selector: "mb-icon", inputs: ["icon", "horizontalFlip", "verticalFlip", "spin"] }, { kind: "directive", type: i3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i1$1.MbButton, selector: "button[mb-button]", inputs: ["variant", "color", "disabled", "loading"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsShareModalComponent, decorators: [{
            type: Component,
            args: [{ encapsulation: ViewEncapsulation.None, providers: [], selector: 'am-experts-share-modal', template: "<div class=\"am-experts-share-modal\">\n  <div class=\"modal-header\">\n    <p>{{translation.shareTitle}}</p>\n    <mb-icon icon=\"close\" (click)=\"modalRef.close()\"></mb-icon>\n  </div>\n  <div class=\"modal-body\">\n    <p class=\"modal-body--instructions\">\n      <mb-icon icon=\"link\"></mb-icon>\n      {{translation.shareInstructions}}\n    </p>\n    <div class=\"modal-body--copy\">\n      <input class=\"modal-body--url\" [(ngModel)]=\"dialogData.url\">\n        <button mb-button variant=\"principal\" color=\"primary\" class=\"modal-body--button\" (click)=\"copyUrl()\">{{translation.shareAction}}</button>\n    </div>\n  </div>\n</div>\n", styles: ["am-experts-share-modal{width:100%}am-experts-share-modal .am-experts-share-modal{font-family:ProximaNova,sans-serif}am-experts-share-modal .am-experts-share-modal *{box-sizing:content-box}am-experts-share-modal .am-experts-share-modal .modal-header{align-items:center;background-color:#dddede;color:#454848;display:flex;font-size:16px;height:auto;padding:0 16px;position:relative;text-align:left}am-experts-share-modal .am-experts-share-modal .modal-header .modal-header-title{font-size:16px;font-weight:700}am-experts-share-modal .am-experts-share-modal .modal-header mb-icon[icon=close]{cursor:pointer;position:absolute;right:21px;top:16px}am-experts-share-modal .am-experts-share-modal .modal-header p{line-height:48px;margin:0}am-experts-share-modal .am-experts-share-modal .modal-header>span{cursor:pointer;line-height:1em;position:absolute;right:16px;top:16px}am-experts-share-modal .am-experts-share-modal .modal-header>span.icon-close:before{content:\"\\ea01\";font-family:am-experts-share}am-experts-share-modal .am-experts-share-modal .modal-body{color:#454848;padding:16px}am-experts-share-modal .am-experts-share-modal .modal-body p.modal-body--instructions{font-size:16px;font-weight:400;line-height:20px;margin:8px 0}am-experts-share-modal .am-experts-share-modal .modal-body p.modal-body--instructions>span{font-size:14px;line-height:1em;margin-right:8px}am-experts-share-modal .am-experts-share-modal .modal-body p.modal-body--instructions>span.icon-link:before{content:\"\\ea03\";font-family:am-experts-share}am-experts-share-modal .am-experts-share-modal .modal-body input{box-sizing:border-box;color:#7c8080}am-experts-share-modal .am-experts-share-modal .modal-body input.modal-body--url{border:1px solid #bcbfbf;border-radius:3px 0 0 3px;font-size:14px;font-weight:400;line-height:17px;margin:8px 0;max-height:48px;outline:none;padding:16px 8px;width:80%}.cdk-overlay-pane.am-experts-share-modal-window{background:#fff;box-shadow:0 5px 15px #00000080;position:absolute!important;top:30px;width:600px}@media only screen and (max-width: 768px){.cdk-overlay-pane.am-experts-share-modal-window{bottom:0;box-shadow:0 5px 15px #00000080;top:0;width:100%}}.modal-body--copy{display:flex}.modal-body--button{margin:12px 0 0 14px}\n"] }]
        }], ctorParameters: function () { return [{ type: TranslationService }, { type: i1$1.MbDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MB_DIALOG_DATA]
                }] }]; }, propDecorators: { close: [{
                type: Input
            }], dismiss: [{
                type: Input
            }], resolve: [{
                type: Input
            }] } });

class AmExpertsShareToastComponent {
    constructor() { }
}
/** @nocollapse */ AmExpertsShareToastComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsShareToastComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ AmExpertsShareToastComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: AmExpertsShareToastComponent, selector: "am-experts-share-toast", ngImport: i0, template: "<div class=\"am-experts-share-toast\">\n  <span class=\"toast-content\">\n    <mb-alert [type]=\"type\">\n      <mb-alert-description>{{message}}</mb-alert-description>\n    </mb-alert>\n  </span>\n</div>\n", styles: [".am-experts-share-toast{animation:fadein .5s;bottom:0;left:0;position:fixed;text-align:center;width:100%;z-index:1}@media only screen and (max-width: 767px){.am-experts-share-toast{padding:8px 0}}.am-experts-share-toast .toast-content{align-items:center;background-color:transparent;display:inline-flex;font-family:ProximaNova,sans-serif;max-width:640px;padding:24px 32px}@media only screen and (max-width: 767px){.am-experts-share-toast .toast-content{padding:8px}}.am-experts-share-toast .toast-content .close-ctn{position:absolute;right:8px}@media only screen and (max-width: 767px){.am-experts-share-toast .toast-content .close-ctn{right:16px}}.am-experts-share-toast .toast-content ::ng-deep am-alert .alert-content{background:#fff}@media only screen and (max-width: 767px){.am-experts-share-toast .toast-content ::ng-deep am-alert .alert-content{padding:8px}}\n"], dependencies: [{ kind: "component", type: i1$1.MbAlert, selector: "mb-alert", inputs: ["type", "arrow", "dismissible"], outputs: ["dismiss"] }, { kind: "component", type: i1$1.MbAlertDescription, selector: "mb-alert-description" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsShareToastComponent, decorators: [{
            type: Component,
            args: [{ selector: 'am-experts-share-toast', template: "<div class=\"am-experts-share-toast\">\n  <span class=\"toast-content\">\n    <mb-alert [type]=\"type\">\n      <mb-alert-description>{{message}}</mb-alert-description>\n    </mb-alert>\n  </span>\n</div>\n", styles: [".am-experts-share-toast{animation:fadein .5s;bottom:0;left:0;position:fixed;text-align:center;width:100%;z-index:1}@media only screen and (max-width: 767px){.am-experts-share-toast{padding:8px 0}}.am-experts-share-toast .toast-content{align-items:center;background-color:transparent;display:inline-flex;font-family:ProximaNova,sans-serif;max-width:640px;padding:24px 32px}@media only screen and (max-width: 767px){.am-experts-share-toast .toast-content{padding:8px}}.am-experts-share-toast .toast-content .close-ctn{position:absolute;right:8px}@media only screen and (max-width: 767px){.am-experts-share-toast .toast-content .close-ctn{right:16px}}.am-experts-share-toast .toast-content ::ng-deep am-alert .alert-content{background:#fff}@media only screen and (max-width: 767px){.am-experts-share-toast .toast-content ::ng-deep am-alert .alert-content{padding:8px}}\n"] }]
        }], ctorParameters: function () { return []; } });

class AmExpertsShareModalService {
    constructor(modal, toastService, translationService) {
        this.modal = modal;
        this.toastService = toastService;
        this.translationService = translationService;
        this.toastConfigByReason = {
            LINK_COPIED: { text: 'defaultSuccess', type: 'success' },
            ERROR: { text: 'defaultError', type: 'error' },
            DEFAULT: { text: 'defaultError', type: 'error' }
        };
    }
    openAmExpertsShareModal(locale, url) {
        const modalRef = this.modal.open(AmExpertsShareModalComponent, {
            hasBackdrop: true,
            closeOnBackdropClick: true,
            closeOnEscKey: true,
            panelClass: 'am-experts-share-modal-window',
            dialogData: {
                locale: locale,
                url: url
            },
        });
        modalRef
            .onClose()
            .subscribe(data => this._handleModalResult(data.reason, locale));
    }
    _handleModalResult(reason, locale) {
        const toastConfig = this.toastConfigByReason[reason] || this.toastConfigByReason['DEFAULT'];
        this.toastService.show({
            component: AmExpertsShareToastComponent,
            componentData: {
                message: this.translationService.getTranslationInstance(locale, toastConfig.text),
                type: toastConfig.type
            },
            timeOut: 5000
        });
    }
}
/** @nocollapse */ AmExpertsShareModalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsShareModalService, deps: [{ token: i1$1.MbDialog }, { token: AmExpertsShareToastService }, { token: TranslationService }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ AmExpertsShareModalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsShareModalService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsShareModalService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.MbDialog }, { type: AmExpertsShareToastService }, { type: TranslationService }]; } });

class AmExpertsShareComponent {
    constructor(cookieService, expertsShareService, modalService, toastService, translationService, viewContainerRef) {
        this.cookieService = cookieService;
        this.expertsShareService = expertsShareService;
        this.modalService = modalService;
        this.toastService = toastService;
        this.translationService = translationService;
        this.viewContainerRef = viewContainerRef;
    }
    ngOnInit() {
        this.url = null;
        this.loading = false;
        this.toastService.setRootViewContainerRef(this.viewContainerRef);
        this.translation = this.translationService.getTranslation(this.locale);
    }
    trackEvent(eventAction, eventLabel) {
        const datalayer = window.dataLayer || [];
        datalayer.push({
            event: 'trackEvent',
            eventCategory: 'Experts',
            eventAction: eventAction,
            eventLabel: eventLabel
        });
    }
    shareProduct(event) {
        event.stopPropagation();
        if (this.loading) {
            return;
        }
        const data = {
            user_id: amLoginGuard.getUserId(),
            context: window.location.toString()
        };
        this.loading = true;
        this.trackEvent('ShareLink', data);
        this.showShareModal(data);
    }
    showShareModal(data) {
        if (data.user_id) {
            this.createShareAndShowModal();
        }
        else {
            this.setUrlAndShowModal();
        }
    }
    createShareAndShowModal() {
        this.expertsShareService.createShare().subscribe({
            next: share => {
                this.setUrlAndShowModal(share);
            },
            error: () => {
                this.showErrorToast();
            }
        });
    }
    setUrlAndShowModal(share) {
        this.url = this.buildUrl();
        if (share) {
            const referer = this.productDetail.includes('?')
                ? `&am_referrer=${share.id}`
                : `?am_referrer=${share.id}`;
            this.url += referer;
        }
        this.modalService.openAmExpertsShareModal(this.locale, this.url);
        this.loading = false;
    }
    showErrorToast() {
        this.toastService.show({
            component: AmExpertsShareToastComponent,
            componentData: {
                message: this.translationService.getTranslationInstance(this.locale, 'defaultError'),
                type: 'error'
            },
            timeOut: 5000
        });
    }
    buildUrl() {
        let shareUrl = this.productDetail;
        shareUrl = shareUrl.replace('ccr.', '');
        shareUrl = shareUrl.replace('experts.', '');
        shareUrl = shareUrl.replace('sucursales.', '');
        shareUrl = shareUrl.replace('viagens', 'ww2');
        return shareUrl;
    }
}
/** @nocollapse */ AmExpertsShareComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsShareComponent, deps: [{ token: i1$2.CookieService }, { token: AmExpertsShareService }, { token: AmExpertsShareModalService }, { token: AmExpertsShareToastService }, { token: TranslationService }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ AmExpertsShareComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: AmExpertsShareComponent, selector: "am-experts-share", inputs: { brand: "brand", channel: "channel", country: "country", locale: "locale", productDetail: "productDetail", size: "size" }, providers: [], ngImport: i0, template: "<div class=\"am-experts-share\">\n  <div class=\"am-experts-share-container hint--bounce hint--left hint--rounded\" [attr.aria-label]=\"translation.shareProduct\">\n    <div class=\"am-experts-share-button\" (click)=\"shareProduct($event)\" [ngClass]=\"size\">\n      <div class=\"am-experts-share-button--icon\" *ngIf=\"!loading\" [ngClass]=\"size\">\n        <mb-icon icon=\"link\"></mb-icon>\n      </div>\n      <div class=\"loader\" *ngIf=\"loading\" [ngClass]=\"size\"></div>\n    </div>\n  </div>\n</div>\n", styles: ["@import\"@angular/cdk/overlay-prebuilt.css\";@keyframes loading{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.am-experts-share-container{display:inline-block;font-family:ProximaNova,sans-serif}.am-experts-share-container .am-experts-share-button{background-color:#fff;border:1px solid #cccccc;border-radius:50%;box-sizing:content-box;cursor:pointer;display:inline-block;height:40px;position:relative;width:40px;z-index:1}.am-experts-share-container .am-experts-share-button.sm{height:32px;width:32px}.am-experts-share-container .am-experts-share-button .am-experts-share-button--icon{color:#1565a1;font-size:22px;left:8px;position:absolute;top:8px}.am-experts-share-container .am-experts-share-button .am-experts-share-button--icon.sm{font-size:16px;left:8px;line-height:16px;top:8px}.am-experts-share-container .am-experts-share-button .loader{animation:loading 1.1s infinite linear;border-bottom:4px solid rgba(26,153,223,.4);border-left:4px solid rgb(26,153,223);border-radius:50%;border-right:4px solid rgba(26,153,223,.4);border-top:4px solid rgba(26,153,223,.4);box-sizing:border-box;font-size:10px;height:24px;margin:auto;position:relative;text-indent:-9999em;top:7px;width:24px}.am-experts-share-container .am-experts-share-button .loader.sm{height:16px;width:16px}\n"], dependencies: [{ kind: "component", type: i1$1.MbIcon, selector: "mb-icon", inputs: ["icon", "horizontalFlip", "verticalFlip", "spin"] }, { kind: "directive", type: i7.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i7.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsShareComponent, decorators: [{
            type: Component,
            args: [{ selector: 'am-experts-share', providers: [], template: "<div class=\"am-experts-share\">\n  <div class=\"am-experts-share-container hint--bounce hint--left hint--rounded\" [attr.aria-label]=\"translation.shareProduct\">\n    <div class=\"am-experts-share-button\" (click)=\"shareProduct($event)\" [ngClass]=\"size\">\n      <div class=\"am-experts-share-button--icon\" *ngIf=\"!loading\" [ngClass]=\"size\">\n        <mb-icon icon=\"link\"></mb-icon>\n      </div>\n      <div class=\"loader\" *ngIf=\"loading\" [ngClass]=\"size\"></div>\n    </div>\n  </div>\n</div>\n", styles: ["@import\"@angular/cdk/overlay-prebuilt.css\";@keyframes loading{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.am-experts-share-container{display:inline-block;font-family:ProximaNova,sans-serif}.am-experts-share-container .am-experts-share-button{background-color:#fff;border:1px solid #cccccc;border-radius:50%;box-sizing:content-box;cursor:pointer;display:inline-block;height:40px;position:relative;width:40px;z-index:1}.am-experts-share-container .am-experts-share-button.sm{height:32px;width:32px}.am-experts-share-container .am-experts-share-button .am-experts-share-button--icon{color:#1565a1;font-size:22px;left:8px;position:absolute;top:8px}.am-experts-share-container .am-experts-share-button .am-experts-share-button--icon.sm{font-size:16px;left:8px;line-height:16px;top:8px}.am-experts-share-container .am-experts-share-button .loader{animation:loading 1.1s infinite linear;border-bottom:4px solid rgba(26,153,223,.4);border-left:4px solid rgb(26,153,223);border-radius:50%;border-right:4px solid rgba(26,153,223,.4);border-top:4px solid rgba(26,153,223,.4);box-sizing:border-box;font-size:10px;height:24px;margin:auto;position:relative;text-indent:-9999em;top:7px;width:24px}.am-experts-share-container .am-experts-share-button .loader.sm{height:16px;width:16px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.CookieService }, { type: AmExpertsShareService }, { type: AmExpertsShareModalService }, { type: AmExpertsShareToastService }, { type: TranslationService }, { type: i0.ViewContainerRef }]; }, propDecorators: { brand: [{
                type: Input
            }], channel: [{
                type: Input
            }], country: [{
                type: Input
            }], locale: [{
                type: Input
            }], productDetail: [{
                type: Input
            }], size: [{
                type: Input
            }] } });

class AmExpertsShareModule {
    constructor(iconRegistry) {
        this.iconRegistry = iconRegistry;
        iconRegistry.addSvgIconDefinition(aci.aciClose);
        iconRegistry.addSvgIconDefinition(aci.aciLink);
    }
}
/** @nocollapse */ AmExpertsShareModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsShareModule, deps: [{ token: i1$1.MbIconRegistry }], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ AmExpertsShareModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsShareModule, bootstrap: [AmExpertsShareComponent], declarations: [AmExpertsShareComponent,
        AmExpertsShareModalComponent,
        AmExpertsShareToastComponent], imports: [MbIconModule,
        CommonModule,
        FormsModule,
        HttpClientModule,
        MbButtonModule,
        MbFormFieldModule,
        MbAlertModule], exports: [AmExpertsShareComponent, AmExpertsShareToastComponent] });
/** @nocollapse */ AmExpertsShareModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsShareModule, providers: [
        AmExpertsShareModalService,
        AmExpertsShareToastService,
        CookieService
    ], imports: [MbIconModule,
        CommonModule,
        FormsModule,
        HttpClientModule,
        MbButtonModule,
        MbFormFieldModule,
        MbAlertModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsShareModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AmExpertsShareComponent,
                        AmExpertsShareModalComponent,
                        AmExpertsShareToastComponent
                    ],
                    exports: [AmExpertsShareComponent, AmExpertsShareToastComponent],
                    imports: [
                        MbIconModule,
                        CommonModule,
                        FormsModule,
                        HttpClientModule,
                        MbButtonModule,
                        MbFormFieldModule,
                        MbAlertModule
                    ],
                    providers: [
                        AmExpertsShareModalService,
                        AmExpertsShareToastService,
                        CookieService
                    ],
                    bootstrap: [AmExpertsShareComponent]
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MbIconRegistry }]; } });

/*
 * Public API Surface of am-experts-share
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AmExpertsShareComponent, AmExpertsShareModalComponent, AmExpertsShareModule, AmExpertsShareService, AmExpertsShareToastComponent };
